// extracted by mini-css-extract-plugin
export default {"bodyLoader":"style_bodyLoader__iuYFQ","loader":"style_loader__X5kjn","mulShdSpin":"style_mulShdSpin__ymcWO"};